import { enforceSupportedNodeVersion } from "./node-version.js";

enforceSupportedNodeVersion();
